import styled from "styled-components";
import { cores } from '../../globalStyle';

export const Hero = styled.header`
    background-color: ${cores.rosaClaro};
    padding: 64px 0 40px 0;
    text-align: center;
`

export const Titulo = styled.h1`
    color: ${cores.rosaEscuro};
    font-weight: 900;
    font-size: 36px;
    line-height: 42px;
    margin-top: 140px;
`